(function () {
    'use strict';

    angular.module('swif.openbase')
        .config(route)
        .factory('swifOpenbaseTeamService', swifOpenbaseTeamService)
        .controller('OpenbaseTeamsController', OpenbaseTeamsController)
        .controller('OpenbaseEditTeamController', OpenbaseEditTeamController)
        .directive('panelTeam', panelTeam);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/teams/table_view', {
            templateUrl: 'partials/openbase/teams_table_view.html',
            controller: 'OpenbaseTeamsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseTeamService
     * @description team manager
     * @requires swif.framework.swifFrameworkService
     **/
    function swifOpenbaseTeamService(swif) {
        'ngInject';
        var service = {};
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate('teams', 'team', filter);
        };
        service.getCollection = function () {
            return swif.collections.getCollection('teams');
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };
        service.preValidate = function (data) {
            return service.getCollection().preValidate(data);
        };
        service.preModal = function (data) {
            return service.getCollection().preModal(data);
        };
        service.modules = swif.module.modules;
        return service;
    }

    function OpenbaseTeamsController($scope, swifOpenbaseTeamService) {
        'ngInject';
        $scope.modules = swifOpenbaseTeamService.modules;
        swifOpenbaseTeamService.createCollection().then(function (collection) {
            $scope.teams = collection;
        });
        $scope.callback = swifOpenbaseTeamService.callback;
        $scope.preValidate = swifOpenbaseTeamService.preValidate;
        $scope.preModal = swifOpenbaseTeamService.preModal;
    }

    function OpenbaseEditTeamController($scope, swif) {
        'ngInject';
        $scope.filters = {
            user: {},
            manager: {},
            department: {}
        };
        swif.data.addFilter($scope.filters.user, 'service_ids', '!=', false);
        swif.data.addFilter($scope.filters.manager, 'service_ids', '!=', false);
    }

    function panelTeam(swif) {
        'ngInject';
        var directive = swif.panel.create_directive('team');
        directive.templateUrl = 'partials/openbase/panel-team.html';
        return directive;
    }

})();
